var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchCheck = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.333 1.25a6.084 6.084 0 0 1 6.084 6.083c0 1.41-.481 2.706-1.286 3.737l2.4 2.4a.752.752 0 0 1-1.061 1.061l-2.4-2.4a6.06 6.06 0 0 1-3.737 1.286 6.084 6.084 0 0 1 0-12.167m0 1.5a4.583 4.583 0 1 0 0 9.167 4.583 4.583 0 0 0 0-9.167m1.47 2.72a.75.75 0 0 1 1.06 1.06L7.196 9.197a.75.75 0 0 1-1.06 0L4.803 7.863a.75.75 0 0 1 1.06-1.06l.803.802z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchCheck);
export default ForwardRef;